import { ProtectionMenuNameOptions } from '../utils/enums';

export class Step {
    index: number;
    title: string;
    content: string;
    contentForGoldLevel?: string;
    protectionType: ProtectionMenuNameOptions;
    route: string;
    selection: string | null;
    isModified: boolean;
    isSameBaseVersion: boolean;

    constructor(init: Partial<Step>) {
        this.index = init.index!;
        this.title = init.title!;
        this.content = init.content!;
        this.protectionType = init.protectionType!;
        this.route = init.route!;
        this.contentForGoldLevel = init.contentForGoldLevel;

        // Default values
        this.selection = init.selection ?? null;
        this.isModified = init.isModified ?? false;
        this.isSameBaseVersion = init.isSameBaseVersion ?? true;
    }
}